const baseUrl = 'https://uscbrl.lat/'

export { baseUrl }